// src/pages/PostDetail/index.jsx
import React from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './index.css';

const PostDetail = ({ location }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const articleId = urlParams.get('id');
  
  const articles = JSON.parse(localStorage.getItem('articles') || '[]');
  const article = articles.find(a => a.id.toString() === articleId);

  if (!article) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <h2>文章不存在</h2>
        <Link to="/archive">
          <Button type="primary">返回归档</Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="post-detail-page">
      <div className="post-header">
        <h1 className="post-title">{article.title}</h1>
        <div className="post-meta">
          <span className="post-date">{article.date}</span>
          <div className="post-tags">
            {Array.isArray(article.tags) ? 
              article.tags.map(tag => (
                <span key={tag} className="tag">{tag}</span>
              )) : 
              article.tags.split(',').map(tag => (
                <span key={tag} className="tag">{tag.trim()}</span>
              ))
            }
          </div>
        </div>
      </div>
      
      <div className="post-content">
        <h3>摘要</h3>
        <p>{article.abstract}</p>
        
        <h3>内容</h3>
        <div className="post-body">
          <Markdown
            remarkPlugins={[remarkGfm]}
            components={{
              img: ({ node, ...props }) => (
                <img 
                  {...props} 
                  style={{ maxWidth: '100%', height: 'auto', margin: '10px 0' }} 
                  alt="图片"
                />
              ),
              a: ({ node, ...props }) => (
                <a 
                  {...props} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ color: '#0066cc' }}
                />
              )
            }}
            children={article.content}
          />
        </div>
      </div>
      
      <div className="post-footer">
        <Link to="/archive">
          <Button type="primary">返回归档</Button>
        </Link>
      </div>
    </div>
  );
};

export default PostDetail;